<template>
    <a href="#contact" @click="open">
        <slot name="link"></slot>
    </a>
</template>

<script>

    import bus from '../lib/Bus';

    export default {
        name      : "ContactModalLink",
        methods   : {
            open(e) {
                e.preventDefault();
                bus.$emit('contact.open');
            },
        }
    }
</script>
